import React from "react";

import { SyncIcon } from "assets";
import "./RefreshButton.scss";

export interface IRefreshButtonProps {
  title?: string;
  className?: string;
  onClick?(): void;
}

const RefreshButton: React.FC<React.PropsWithChildren<IRefreshButtonProps>> = ({
  title,
  className,
  onClick,
}) => {
  return (
    <button
      className={`c-refresh-button ${className ?? ""}`}
      title={title}
      onClick={onClick}
      tabIndex={0}
    >
      <SyncIcon width={30} height={30} />
    </button>
  );
};

export default RefreshButton;
